export default __webpack_public_path__ + "static/media/transactions_root_background.241ba627.jpg";